import { ToastLevel, ToastType, Type } from '@philips-internal/oswald-ui-constants';
import { ToastResponse } from '../interfaces/ToastResponse';
import { ReactElement } from 'react';
import { ToastService } from '@philips-internal/oswald-ui-components';
import { generateUUID } from '@philips-internal/oswald-ui-utils';

/**
 * @deprecated
 * Use {@link showToastNotification} instead.
 */
export function showToastNotificationMessage(resp: ToastResponse, highlight?: boolean, title?: string): void {
  const type = (resp.type ? resp.type : '').toLocaleLowerCase() as Type;
  const toastLevel = getToastLevel(type);

  resp.messages.forEach(message => showToastNotification({ highlight, level: toastLevel, message, timeout: DEFAULT_TIMEOUT.NONE, title }));
}

function getToastLevel(type: Type): ToastLevel {
  switch (type) {
    case Type.DANGER: return ToastLevel.ERROR;
    case Type.SAFETY: return ToastLevel.SUCCESS;
    default: return ToastLevel.WARNING;
  }
}

interface DefaultToastNotificationProps {
  action?: ReactElement,
  highlight?: boolean,
  id?: string,
  level: ToastLevel,
  message: string,
  timeout?: number,
  title?: string,
  toastType?: ToastType,
}

export const DEFAULT_TIMEOUT = {
  LONG: 7000,
  MEDIUM: 5000,
  NONE: 0,
  SHORT: 3000,
}

export function showToastNotification(props: DefaultToastNotificationProps): string {
  const { action, highlight, level, message, timeout = DEFAULT_TIMEOUT.MEDIUM, title, toastType = ToastType.BUBBLE, id, } = props;
  const toastId = id ?? generateUUID();

  ToastService.open({
    action: action,
    dismissible: true,
    highlight: highlight,
    id: toastId,
    level: level,
    message: message,
    offset: 0,
    showIcon: true,
    timeout: timeout,
    title: title,
    type: toastType,
  });

  return toastId;
}

export function showToastNotificationSuccess(message: string, timeout?: number, highlight?: boolean, title?: string, action?: ReactElement): string {
  return showToastNotification({ action, highlight, level: ToastLevel.SUCCESS, message, timeout, title });
}

export function showToastNotificationInformation(message: string, timeout?: number, highlight?: boolean, title?: string, action?: ReactElement): string {
  return showToastNotification({ action, highlight, level: ToastLevel.INFORMATION, message, timeout, title });
}

export function showToastNotificationWarning(message: string, timeout?: number, highlight?: boolean, title?: string, action?: ReactElement): string {
  return showToastNotification({ action, highlight, level: ToastLevel.WARNING, message, timeout, title });
}

export function showToastNotificationCaution(message: string, timeout?: number, highlight?: boolean, title?: string, action?: ReactElement): string {
  return showToastNotification({ action, highlight, level: ToastLevel.CAUTION, message, timeout, title });
}

export function showToastNotificationError(message: string, timeout?: number, highlight?: boolean, title?: string, action?: ReactElement): string {
  return showToastNotification({ action, highlight, level: ToastLevel.ERROR, message, timeout, title });
}

export function closeToastNotification(toastId: string): void {
  ToastService.close(toastId);
}
